import React from 'react';

const StudentsContext = React.createContext();

const StudentsProvider = (props) => {
  return (
    <StudentsContext.Provider value={props.value}>
      {props.children}
    </StudentsContext.Provider>
  );
};

export { StudentsContext, StudentsProvider}
